module.exports = __webpack_public_path__ + "media/images/promo/bg_card_1-54cf6f230779708af9356f7b22a81bfd.jpg";